import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { GradientTypography } from '../gradients/GradientTypography';
import { DownloadGameDialogProps } from './DownloadGameDialog';

export type DownloadGameDialogHeaderProps = Pick<
  DownloadGameDialogProps,
  'recRequirements' | 'title'
>;

export function DownloadGameDialogHeader({
  recRequirements,
  title,
}: DownloadGameDialogHeaderProps) {
  return (
    <Box sx={{ textAlign: 'center' }}>
      <GradientTypography
        sx={{
          textTransform: 'uppercase',
          pt: 6,
        }}
        variant="h3"
        gradientColor="primary.vertical"
      >
        Download {title}
      </GradientTypography>
      <Typography variant="body1" color="text.secondary">
        {title} is available to the public for{' '}
        {recRequirements.length >= 2
          ? `${recRequirements[0].name}
      and ${recRequirements[1].name}`
          : `${recRequirements[0].name}`}
        .
      </Typography>
    </Box>
  );
}
